import { useEffect } from "react";
import { useLazyGetFileByObjectIdAndTypeQuery } from "../../../../../redux/api/FileApi";
import ConfirmModal from "../../../../common/components/ConfirmModal";
import { exportFile } from "../../../../common/ts/CommonFunctions";
import { fileTypes } from "../../../../common/types/types";

interface Props {
    pauseVisible: boolean,
    togglePauseVisible: () => void,
    note?: string,
    productId: number,
    statuteId: number,
    pauseStatute: boolean
}

const PauseReasonModal = ({ pauseVisible, togglePauseVisible, note, productId, statuteId, pauseStatute }: Props) => {
    const [fileTrigger, fileResponse] = useLazyGetFileByObjectIdAndTypeQuery();

    useEffect(() => {
        if (pauseStatute) {
            fileTrigger({ objectId: statuteId, objectType: fileTypes.STOP_STATUTE_REASON })
        } else {
            fileTrigger({ objectId: productId, objectType: fileTypes.STOP_PRODUCT_REASON, storageType: statuteId.toString() })
        }
    }, [fileTrigger, pauseStatute, productId, statuteId])

    const downloadFile = (id: number, fileName: string) => {
        let url = process.env.REACT_APP_API_URL + `/files/downloadFile/${id}`;
        exportFile(url, fileName);
    }

    return (
        <ConfirmModal
            noCancelButton
            visible={pauseVisible}
            onCancel={togglePauseVisible}
            onOk={togglePauseVisible}
            status="error"
            title={<>
                <div>Tài sản đã bị tạm dừng bởi Đấu giá viên</div>
                <div>Lý do tạm dừng: {note || ""}</div>
                {fileResponse.data?.length ?
                    <div className="text-overflow-custom-one-line">File đính kèm: <span className="anchor-text" onClick={() => downloadFile(fileResponse.data?.[0].attachmentId || 0, fileResponse.data?.[0].fileName || "")}>{fileResponse.data?.[0]?.fileName}</span></div>
                    : <></>}
            </>}
        />
    )
}

export default PauseReasonModal;